// backend/widget/src/lib/ackStatus.ts
//
// Quick win widget §8 (audit ergonomie 30/09) : en mode humain (aiMode
// 'off', prod actuelle AI_MODE=off), le visiteur n'avait strictement aucun
// retour après l'envoi d'un message — la bulle "…" est réservée au mode IA
// (cf. commentaire historique dans App.tsx). On affiche à la place une ligne
// d'état discrète dès que l'ack serveur du dernier message visiteur est
// arrivé et tant qu'aucune réponse agent/IA n'est encore là.
//
// Délibérément PURE et dérivée à la volée depuis `store.messages` : ce n'est
// ni un message stocké dans le store, ni persisté en localStorage (contrat :
// ne pas perturber le mécanisme de merge/dédup du 30/09, cf. state/store.ts
// mergeHistory/confirmAck).

import type { AiMode, AvailabilityState, Message } from '../state/store.js';

export type AckDisplayState = 'none' | 'online' | 'offline';

export function deriveAckState(params: {
  messages: Message[];
  aiMode: AiMode;
  availability: AvailabilityState;
}): AckDisplayState {
  // La bulle "…" (aiThinking) fait déjà ce travail en mode IA active — pas
  // besoin (et pas souhaitable) d'empiler les deux indicateurs.
  if (params.aiMode !== 'off') return 'none';
  const last = params.messages[params.messages.length - 1];
  if (!last || last.role !== 'visitor') return 'none';
  // Pas encore confirmé par le serveur (ack pas encore reçu, cf. confirmAck) —
  // rien à afficher tant que l'id reste un id local optimiste.
  if (last.id.startsWith('local-')) return 'none';
  return params.availability === 'offline' ? 'offline' : 'online';
}
